<app-tabla
  [totalCount]="totalCount"
  [datos]="comandos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [filtros]="filtros"
  [crear]="botonCrear"
  [emptyState]="{ title: 'Todavía no hay comandos', subtitle: 'Los comandos enviados a este vehículo aparecen acá.' }"
></app-tabla>
